export default function SolicitacaoCompra(){
    return "Solicitação de Compra"
}